import { render, staticRenderFns } from "./WarehouseTerritoryForm.vue?vue&type=template&id=2cedc845"
import script from "./WarehouseTerritoryForm.vue?vue&type=script&lang=js"
export * from "./WarehouseTerritoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports